/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsComparisonPistols = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsComparisonPistols = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');
      let $sliderMobileEl = $section.find('[data-mobile-slider]');
      
      if (this.collection_style == 'slider') {
        this.createSlider($sliderEl);
      }
      else if(window.innerWidth < 799){
        this.createSlider($sliderMobileEl);
      }
    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: false,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'center',
        adaptiveHeight: true,
        // wrapAround: true,
        groupCells: true,
        pageDots: false,
        contain: true,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
        initialIndex: 0,
        arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;